import { ConfigForm as form, marshal } from './ConfigForm'

const provider = {
  label: 'Shaarli',
  form,
  marshal 
}

export default provider
